import axios from 'axios'
import { getBackendUrl } from './general'


export const getKey = async (user, psswrd) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/api/getKey`,
      {
        username: user,
        password: psswrd
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const verifyToken = async (token) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/api/verifyKey`,
      {
        token: token
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    return null
  }
}

export const refreshToken = async (tokenRefresh) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/api/refreshKey`,
      {
        refresh: tokenRefresh
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const actualizaSesionUsuario = async (context, uid, status) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.put(
      `${source}/seguridad/api/actualizaSesionUsuario/${uid}`,
      {
        "Estado": status
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const validaSesionUsuario = async (context, uid) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/seguridad/api/validaSesionUsuario/${uid}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const solicitaClaveUsuario = async (user) => {
  try {
    const { source } = await getBackendUrl()
    await axios.get(
      `${source}/seguridad/api/solicitudClaveUsuario?usr=${user}`
    )
  } catch(err) {
    console.log(err);
    throw err
  }
}

export const validaClaveUsuario = async (key) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/seguridad/api/validacionCambioClaveUsuario?K=${key}`
    )

    return res.data
  } catch(err) {
    console.warn("Hola...", err);
    throw err
  }
}

export const asignaNuevaClaveUsuario = async (token, idB64, newPassword) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.patch(
      `${source}/seguridad/api/cambioClaveUsuario`,
      {
        "Token": token,
        "Id_B64": idB64,
        "Clave_Nueva": newPassword
      }
    )

    return res.data
  } catch(err) {
    console.warn(err);
    throw err
  }
}

export const cambioClaveUsuario = async (context, oldPassword, newPassword) => {
  try {
    const { source } = await getBackendUrl()
    const res = await axios.put(
      `${source}/archivo/api/cambioClaveUsuario`,
      {
        "Clave_Anterior": oldPassword,
        "Clave_Nueva": newPassword
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const downloadFileObject = (fileName, fileExtension, base64String) => {
  base64String = `data:application/${fileExtension};base64,${base64String}`

  const linkSource = base64String
  const downloadLink = document.createElement("a")

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

// Parameters:
// contentType: The content type of your file. 
//              its like application/pdf or application/msword or image/jpeg or
//              image/png and so on
// base64Data: Its your actual base64 data
// fileName: Its the file name of the file which will be downloaded. 
export const downloadBase64File = async (contentType, base64Data, fileName) => {
  const linkSource = `data:${contentType};base64,${base64Data}`;
  const downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

export const dataConsumosPedidosCliente = async (context, startDate, endDate, idDirectory, idDependency = '', idCiiu = '') => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const body = {
      Fecha_Inicial: startDate,
      Fecha_Final: endDate,
      Id_Directorio: idDirectory
    }

    idDependency ? body["Id_Dependencia"] = idDependency : null
    idCiiu ? body["Id_Ciiu"] = idCiiu : null

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataConsumosPedidos`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridVentasCliente = async (context, idDirectory, idDependency = '', startDate, endDate) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const body = {
      Id_Directorio: idDirectory,
      Id_Dependencia: idDependency
    }

    startDate ? body["Fecha_Inicial"] = startDate : null
    endDate ? body["Fecha_Final"] = endDate : null
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridVentasCliente`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridProductosPedidos = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridProductosPedidos`,
      {
        Id_Directorio: idDirectory,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridProductosCotizaciones = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridProductosCotizaciones`,
      {
        Id_Directorio: idDirectory,
        Id_Ciiu: 'MIGUf9Bx2Fd1Nz2Qx3Jc'
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const searchDirectorio = async (context, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/busquedas/api/searchDirectorio/?search=${search}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

// export const searchProducto = async (context, filter) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.post(
//       `${source}/busquedas/api/searchProducto`,
//       {
//         filtro: filter,
//       },
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

export const searchProductos = async (context, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/busquedas/api/searchProductos/?search=${search}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridCampanias = async (
  context,
  page,
  search
) => {
  try {
    // let employeePath = context.$store.state.user.data.tipo_Empleado === 'V' ? `id=${idEmployee}` : ''
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `${pagePath}${searchPath}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/mercadeo/api/dataGridCampanias/?${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridOportunidades = async (
  context,
  page,
  search
) => {
  try {
    // let employeePath = context.$store.state.user.data.tipo_Empleado === 'V' ? `id=${idEmployee}` : ''
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `${pagePath}${searchPath}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/mercadeo/api/dataGridOportunidades/?${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridEstadoCuenta = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridEstadoCuenta`,
      {
        Id_Directorio: idDirectory,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridEstadoCuentaCliente = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridEstadoCuentaCliente`,
      {
        Id_Directorio: idDirectory,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridEstadoCuentaProveedor = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridEstadoCuentaProveedor`,
      {
        Id_Directorio: idDirectory,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridPedidos = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGridPedidos`,
      {
        Id_Directorio: idDirectory,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataPedidoMovimientos = async (context, idOrder) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataPedidoMovimientos`,
      {
        "Id_Pedido": idOrder,
        "Tipo_Datos": "M"
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export async function actualizaPedido(
  context,
  body
) {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/actualizaPedido`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export async function grabaImagenProducto(
  context,
  productId,
  fileName,
  fileBase64
) {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaImagenProducto`,
      {
        "Id_Producto": productId,
        "Nombre_Archivo": fileName,
        "Archivo_Base64": fileBase64
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export async function grabaImagenPersonal(
  context,
  personalId,
  imageType,
  fileName,
  fileBase64
) {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaImagenPersonal`,
      {
        "Id_Personal": personalId,
        "Tipo_Imagen": imageType,
        "Nombre_Archivo": fileName,
        "Archivo_Base64": fileBase64
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const grabaPedido = async (
  context,
  idDirectory,
  idDependency,
  idUser,
  items,
  fileExtension,
  fileBase64,
  pursharseOrder,
  comments1,
  comments2
) => {
  try {
    const body = {
      "Id_Directorio": idDirectory,
      "Id_Dependencia": idDependency,
      // "usuario_Elaboro": idUser,
      "Productos": items.map(item => {
        return {
          "Id_Producto": item.id_Producto,
          "Cantidad": item.cantidad,
          "Valor_Producto": item.valor_Producto,
          "Comentarios": item.comentarios.length ? item.comentarios : null
        }
      }),
      "Nombre_Archivo": fileExtension,
      "Archivo_Base64": fileBase64
    }

    pursharseOrder.length ? body["Orden_Compra"] = context.pursharseOrder : null
    comments1.length ? body["Comentario_01"] = context.comments1 : null
    comments2.length ? body["Comentario_02"] = context.comments2 : null
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaPedido`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const grabaCotizacion = async (
  context,
  idDirectory,
  idDependency,
  validDays,
  items,
  comments1,
  comments2
) => {
  try {
    const body = {
      "Id_Directorio": idDirectory,
      "Id_Dependencia": idDependency,
      "Productos": items.map(item => {
        return {
          "Id_Producto": item.id_Producto,
          "Cantidad": parseFloat(item.cantidad),
          "Valor_Producto": parseFloat(item.valor_Producto),
          "Comentarios": item.comentarios ? item.comentarios : null,
          "Proveedor": item.nombre_Proveedor ? item.nombre_Proveedor : null,
          "Valor_Proveedor": item.valor_Proveedor ? item.valor_Proveedor : null,
          "Tipo_Moneda": item.tipo_Moneda ? item.tipo_Moneda : null,
          "Numero_Parte": item.numero_Parte ? item.numero_Parte : null,
          "Observaciones": item.observaciones ? item.observaciones : null
        }
      })
    }

    body["Dias_Validez"] = validDays ? validDays : 0
    comments1 ? body["Comentario_01"] = comments1 : null
    comments2 ? body["Comentario_02"] = comments2 : null
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaCotizacion`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const actualizaCotizacion = async (
  context,
  idQuote,
  idDirectory,
  idDependency,
  validDays,
  items,
  comments1,
  comments2
) => {
  try {
    const body = {
      "Id_Directorio": idDirectory,
      "Id_Dependencia": idDependency,
      "Productos": items.map(item => {
        return {
          "Id_Producto": item.id_Producto,
          "Cantidad": parseFloat(item.cantidad),
          "Valor_Producto": parseFloat(item.valor_Producto),
          "Comentarios": item.comentarios ? item.comentarios : null
        }
      })
    }

    body["Dias_Validez"] = validDays ? validDays : 0
    comments1 ? body["Comentario_01"] = comments1 : null
    comments2 ? body["Comentario_02"] = comments2 : null
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.put(
      `${source}/movimientos/api/grabaCotizacion/${idQuote}`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const obtenerCotizacion = async (context, idQuote) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/obtenerCotizacion/${idQuote}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (error) {
    console.log(error)
    throw error.response
  }
}

export const grabaDocumentoAnexo = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/documentoAnexo`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.error(err)
    throw err.response
  }
}

export const borraDocumentoAnexo = async (context, id) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.delete(
      `${source}/movimientos/api/documentoAnexo/${id}`,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.error(err)
    throw err.response
  }
}

export const grabaGarantiaCliente = async (
  context,
  id,
  billPrefix,
  billNumber,
  productType,
  qty,
  code,
  serialNumber,
  observations,
  name,
  tel,
  email,
  fileExtension,
  fileBase64
) => {
  try {
    const body = {
      "Identificacion": id,
      "Prefijo_Factura": billPrefix,
      "Numero_Factura": billNumber,
      "Tipo_Producto": productType,
      "Cantidad": qty,
      "Codigo_Producto": code,
      "Serial_Numero": serialNumber,
      "Observaciones": observations,
      "Nombre_Contacto": name,
      "Telefono_Contacto": tel,
      "CorreoElectronico_Contacto": email,
      "Nombre_Archivo": fileExtension,
      "Archivo_Base64": fileBase64
    }
    console.log(body)
    Object.keys(body).forEach(key => {
      body[key] ? null : delete body[key]
    })
    // console.log(body)
    // await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaGarantiaCliente`,
      body,
      // {
      //   headers: {
      //     'Authorization': `Bearer ${context.$store.state.user.token}`
      //   }
      // }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const grabaSeguimientoGarantia = async (
  context,
  idWarranty,
  status,
  date,
  observations,
  fileExtension,
  fileBase64
) => {
  try {
    const body = {
      "Id_Garantia": idWarranty,
      "Fecha_Seguimiento": date,
      "Estado": status,
      "Observaciones": observations,
      "Nombre_Archivo": fileExtension,
      "Archivo_Base64": fileBase64
    }
    console.log(body)
    Object.keys(body).forEach(key => {
      body[key] ? null : delete body[key]
    })
    // console.log(body)
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/grabaSeguimientoGarantia`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataProducto = async (context, idProducto) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataProducto/${idProducto}/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListEstablecimientos = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/directorio/${idDirectory}/dataListEstablecimientos/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListDependencias = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/directorio/${idDirectory}/dataListDependencias/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataUsuarioSession = async (context, token) => {
  try {
    const mtoken = context.$store.state.user.token ? context.$store.state.user.token : token
    // await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataUsuarioSession`,
      {
        headers: {
          'Authorization': `Bearer ${mtoken}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListCiudades = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListCiudades/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListBarrios = async (context, idCity) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/ciudad/${idCity}/dataListBarrios/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListZonas = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListZonas/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListTiposIdenticacion = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListTiposIdenticacion/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListClasesSeguimientos = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataListClasesSeguimientos/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const dataListTiposResponsabilidadFiscal = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListTiposResponsabilidadFiscal/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListTiposIndustrias = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListTiposIndustrias/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListTiposClasificacionClientes = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListTiposClasificacionClientes/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridGarantiasCliente = async (context, page) => {
  try {
    let pagePath = page ? `?page=${page}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridGarantiasCliente${pagePath}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const consultaGarantiaCliente = async (context, prefijo, numero, hash) => {
  try {
    const prefix = prefijo ? `&P=${prefijo}` : ''
    // await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/consultaGarantiaCliente?N=${numero}&K=${hash}${prefix}`,
      // {
      //   headers: {
      //     'Authorization': `Bearer ${context.$store.state.user.token}`
      //   }
      // }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGeolocalizacionDocumento = async (context, id) => {
  try {
    const idd = id ? `&id=${id}` : null
    if (!idd) {
      throw "no id provided"
    }
    // await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGeolocalizacionDocumento?${idd}`,
      // {
      //   headers: {
      //     'Authorization': `Bearer ${context.$store.state.user.token}`
      //   }
      // }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridSeguimientosGarantia = async (context, id) => {
  try {

    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridSeguimientosGarantia/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataEjecucionPresupuestoCategorias = async (context, typeReport, initialPeriod, finalPeriod, idEmployee, idCategory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const body = {
      Tipo_Reporte: typeReport,
      Periodo_Inicial: initialPeriod,
      Periodo_Final: finalPeriod,
    }

    idEmployee ? body["Id_Empleado"] = idEmployee : null
    idCategory ? body["Id_Categoria"] = idCategory : null
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataEjecucionPresupuestoCategorias`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataConsumosPedidosCategorias = async (context, typeReport, initialPeriod, finalPeriod, idEmployee, idCategory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const body = {
      Tipo_Reporte: typeReport,
      Periodo_Inicial: initialPeriod,
      Periodo_Final: finalPeriod,
    }

    idEmployee ? body["Id_Empleado"] = idEmployee : null
    idCategory ? body["Id_Categoria"] = idCategory : null
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataEjecucionPresupuestoCategorias`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dependencias = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dependencias`,
      {
        Id_Directorio: idDirectory
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListPersonal = async (context, ltype) => {
  try {
    const type = ltype === 'L' ? 'logistica' : 'vendedores'
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListPersonal/?tipo=${type}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListCampania = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListCampania/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListFasesVentas = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListFasesVentas/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListGruposOportunidades = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListGruposOportunidades/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataListOrigenesOportunidades = async (context) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataListOrigenesOportunidades/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const obtenerDirectorio = async (context, idDirectory) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/archivo/api/directorio/${idDirectory}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const obtenerProducto = async (context, id) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/archivo/api/producto/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const obtenerDependencia = async (context, idDependency) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/archivo/api/dependencia/${idDependency}/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const guardaOportunidad = async (
  context,
  employee,
  directory,
  dependency,
  campaign,
  opportunityOrigin,
  opportunityGroup,
  sellPhase,
  description,
  observations,
  expectedBusinessValue,
  priority
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const body = {
      "Id_Empleado": employee,
      "Id_Directorio": directory,
      "Id_OrigenOportunidad": opportunityOrigin,
      "Id_GrupoOportunidad": opportunityGroup,
      "Id_FaseVenta": sellPhase,
      "Descripcion": description,
      "Observaciones": observations,
      "Valor_NegocioPrevisto": expectedBusinessValue,
      "Prioridad": priority
    }
    dependency ? body["Id_Dependencia"] = dependency : null
    campaign ? body["Id_Campania"] = campaign : null
    const res = await axios.post(
      `${source}/mercadeo/api/oportunidad/`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const guardarCampania = async (
  context,
  name,
  dateStart,
  dateEnd,
  status,
  description
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const body = {
      "nombre_Campania": name,
      "fecha_Inicial": dateStart,
      "fecha_Final": dateEnd,
      "estado": status
    }
    description ? body["descripcion"] = description : null
    const res = await axios.post(
      `${source}/mercadeo/api/campania/`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const actualizarCampania = async (
  context,
  id,
  name,
  dateStart,
  dateEnd,
  status,
  description
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.put(
      `${source}/mercadeo/api/campania/${id}/`,
      {
        "nombre_Campania": name,
        "fecha_Inicial": dateStart,
        "fecha_Final": dateEnd,
        "estado": status,
        "descripcion": description
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const obtenerCampania = async (
  context,
  id
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/mercadeo/api/campania/${id}/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const actualizarEstadoSeguimientosPorUsuario = async (
  context,
  idTracking,
  status
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.put(
      `${source}/mercadeo/api/seguimiento/${idTracking}`,
      {
        "Estado": status
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const guardarDependencia = async (context, dependency) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/archivo/api/dependencia/`,
      dependency,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const guardarSeguimiento = async (context, data,) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/mercadeo/api/seguimiento/`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const actualizarDependencia = async (context, idDependency, dependency) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.put(
      `${source}/archivo/api/dependencia/${idDependency}/`,
      dependency,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const borrarDependencia = async (context, idDependency) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.delete(
      `${source}/archivo/api/dependencia/${idDependency}/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const borrarCampania = async (context, idCampaign) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.delete(
      `${source}/mercadeo/api/campania/${idCampaign}/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const borrarCotizacion = async (context, id) => {
  context
  id
  // try {
  //   await context.$store.dispatch('statusLogin', context.$router)
  //   const {source} = await getBackendUrl()
  // const res = await axios.delete(
  //     `${source}/movimientos/api/productoArrendamiento/${id}/`,
  //     {
  //       headers: {
  //         'Authorization': `Bearer ${context.$store.state.user.token}`
  //       }
  //     }
  //   )
  //   return res.data
  // } catch (err) {    
  //   console.log(err)
  //   throw err.response
  // }
}

export const enviarCotizacion = async (context, idDocument) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/enviaCorreoCotizacion`,
      {
        Id_Documento: idDocument
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDirectorio = async (
  context,
  page,
  search,
  directoryType
) => {
  try {
    let employeePath = context.$store.state.user.data.tipo_Empleado === 'V' ? `&id=${context.$store.state.user.data.id_Empleado}` : ''
    let searchPath = ((search == undefined) || (search == "")) ? '' : '&search=' + search
    let employeeInfo = directoryType === 'cliente' ? employeePath : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGridDirectorio/?page=${page}${searchPath}&tipo=${directoryType}${employeeInfo}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridNotificacionesUsuario = async (
  context,
  idEmployee,
  page,
  search
) => {
  try {
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `?${pagePath}${searchPath}` : ''

    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/mercadeo/api/dataGridNotificaciones/${idEmployee}/${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDocumentos = async (
  context,
  idEmployee,
  idDirectory,
  page,
  search,
  documentType,
  status
) => {
  try {
    let employeePath = context.$store.state.user.data.tipo_Empleado === 'V' ? `&ide=${idEmployee}` : ''
    let directoryPath = idDirectory ? `&idc${idDirectory}` : ''
    let searchPath = ((search == undefined) || (search == "")) ? '' : '&search=' + search
    let statusPath = ((status === undefined) || (status === "")) ? "" : "&estado=" + status

    // const pathId = context.$store.state.user.data.tipo_Empleado === 'V' ? `/${idEmployee}` : ''
    // const pathId = idEmployee ? `/${idEmployee}` : ''

    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGridDocumentos/${documentType}/?page=${page}${searchPath}${employeePath}${directoryPath}${statusPath}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGraficoVentasMensualesCliente = async (context, idDirectory, initDate, endDate, idDependency) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataGraficoVentasMensualesCliente`,
      {
        Id_Directorio: idDirectory,
        Fecha_Inicial: initDate,
        Fecha_Final: endDate,
        Id_Dependencia: idDependency
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataCarteraVendedores = async (
  context,
  documentsType,
  reportType,
  portafolioType,
  portafolioDays,
  idEmployee
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/consultas/api/dataCarteraVendedores`,
      {
        Tipo_Documentos: documentsType,
        Tipo_Reporte: reportType,
        Tipo_Cartera: portafolioType,
        Dias_Cartera: portafolioDays,
        Id_Empleado: idEmployee
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridControlDocumentos = async (
  context,
  startDate,
  endDate,
  idEmployee,
  idSeller
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const body = {
      "Fecha_Inicial": startDate,
      "Fecha_Final": endDate,
      "Id_Empleado": idEmployee,
      "Id_Comercial": idSeller
    }
    const res = await axios.post(
      `${source}/consultas/api/dataGridControlDocumentos`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const crearDirectorioProspecto = async (
  context,
  directory
) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    directory.companyName = directory.companyName ? directory.companyName : `${directory.name1} ${directory.name2} ${directory.lastName1} ${directory.lastName2}`
    const body = {
      "tipo_Identificacion": directory.idType,
      "identificacion": directory.id,
      "dv": directory.digit,
      "empresa": directory.companyName,
      "apellido_01": directory.lastName1,
      "apellido_02": directory.lastName2,
      "nombre_01": directory.name1,
      "nombre_02": directory.name2,
      "direccion": directory.address,
      "direccion_Aux": directory.auxAddress,
      "ciudad": directory.city,
      "barrio": directory.neighborhood,
      "zona": directory.zone,
      "codigo_Postal": directory.zipCode,
      "grupo_Directorio": "",
      "tipo_Industria": directory.industryType,
      "tipo_Clasificacion_Cliente": directory.customerClassType,
      "personal": directory.servedBy,
      "regimen_Iva": "",
      "tipo_Persona": directory.personType,
      "tipoResponsabilidadFiscal": directory.fiscalDuty,
      "observaciones": directory.comments,
      "correo_Electronico": ""
    }

    Object.keys(body).forEach(key => {
      if (!body[key].length) {
        delete body[key]
      }
    })
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/archivo/api/directorio/prospecto`,
      body,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err.response)
    throw err.response
  }
}

export const grabaAccesoUsuario = async (
  context,
  user,
  access
) => {
  try {

    const body = {
      "Usuario": user,
      "Acceso": access
    }

    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/seguridad/api/grabaAccesoUsuario`,
      body
    )
    return res.data
  } catch (err) {
    console.log(err.response)
    return err.response
  }
}